import { resultDetailsActionTypes } from './Constants';

export function getResultDetailsRequest(id, query) {
	return {
		type: resultDetailsActionTypes.GET_RESULT_DETAILS_REQUEST,
		payload: {
			id,
			query,
		},
	};
}

export function getResultDetailsSuccess(data) {
	return {
		type: resultDetailsActionTypes.GET_RESULT_DETAILS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getResultDetailsError() {
	return {
		type: resultDetailsActionTypes.GET_RESULT_DETAILS_ERROR,
	};
}

export function getExerciseTypesRequest() {
	return {
		type: resultDetailsActionTypes.GET_EXERCISE_TYPES_REQUEST,
	};
}

export function getExerciseTypesSuccess(exerciseTypes) {
	return {
		type: resultDetailsActionTypes.GET_EXERCISE_TYPES_SUCCESS,
		payload: {
			exerciseTypes,
		},
	};
}

export function getExerciseTypesError() {
	return {
		type: resultDetailsActionTypes.GET_EXERCISE_TYPES_ERROR,
	};
}

export function cleanExerciseTypesState() {
	return {
		type: resultDetailsActionTypes.CLEAN_EXERCISE_TYPES_STATE,
	};
}

export function openRatingModal() {
	return {
		type: resultDetailsActionTypes.OPEN_RATING_MODAL,
	};
}
